import { ASSIGNEE_ENTITY_KEYS, WEB_APP_ENTITY_KEYS } from '@/utils/entity-keys'

export const handleAdministratorsList = ({ allAdministrators, usersList }) => {
  return usersList
    .map(user => {
      return {
        ...user,
        alreadyAdded: allAdministrators.some(
          admin => user[ASSIGNEE_ENTITY_KEYS.ACCOUNT_ID] === admin[ASSIGNEE_ENTITY_KEYS.ACCOUNT_ID]
        ),
        [WEB_APP_ENTITY_KEYS.PLATFORM_IDS]: user[WEB_APP_ENTITY_KEYS.PLATFORM_IDS] || []
      }
    })
    .sort((a, b) => {
      return a.alreadyAdded - b.alreadyAdded
    })
}
